import {Tr} from "@/i18n/i18n";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ProfileBanPanel extends HorizontalStandardPanel {

    private callback!: (timeInSeconds: number) => void

    constructor(scene: Scene, canvas: HTMLCanvasElement, callback: (timeInSeconds: number) => void) {
        super(scene, canvas, Tr('zabanit.igroka'));

        this.setDepth(3001);

        this.scene = scene;
        this.callback = callback;

        let icon = SpriteUtils.addSprite(this.scene, 0, -110, Keys.UI_WARNING);
        SpriteUtils.setDispSize(icon, 90, 90);

        let infoText = TextUtils.addTextByFamily(scene, Tr('viberite.vremja.na.kotoroe.hotite.zabanit.igroka'),
            0, icon.y / CU.S + 75, '#ffd465', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        this.add([icon, infoText]);

        this.prepareBanOptions();

    }

    private prepareBanOptions() {

        let initX: number = -170;
        let initY: number = 40;

        this.initTimeButton(initX, initY, Tr('minut.30'), 1800);
        this.initTimeButton(initX + 115, initY, Tr('1h'), 3600);
        this.initTimeButton(initX + 230, initY, Tr('3h'), 10800);
        this.initTimeButton(initX + 345, initY, Tr('6h'), 21600);

        // ===================

        this.initTimeButton(initX, initY + 60, Tr('12h'), 43200);
        this.initTimeButton(initX + 115, initY + 60, Tr('1d'), 86400);
        this.initTimeButton(initX + 230, initY + 60, Tr('3d'), 259200);
        this.initTimeButton(initX + 345, initY + 60, Tr('1w'), 604800);

        // ===================

        this.initTimeButton(initX + 115, initY + 120, Tr('2w'), 1209600);
        this.initTimeButton(initX + 230, initY + 120, Tr('navsegda'), 3153600000);

    }

    private initTimeButton(x: number, y: number, text: string, timeInSec: number) {

        let fontSize = 10;

        let btnImage = SpriteUtils.addSprite(this.scene, x, y, Keys.ATLAS_UI, Keys.UI_BUTTON_BROWN_SMALL, 0.6);
        let btnText = TextUtils.addTextByFamily(this.scene, text,
            btnImage.x / CU.S, btnImage.y / CU.S, '#ffffff', fontSize, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        btnImage.setInteractive().on('pointerup', () => {
            if (this.callback != null) {
                this.callback(timeInSec);
                this.destroy();
            }
        });

        this.add([btnImage, btnText]);
    }
}
